import { fetchJson } from '../../apiBase';

export async function fetchSmartboardMessageStatus(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/teacher-message`);
  return parseResponse(res, 'Akıllı tahta durumu alınamadı.');
}

export async function sendSmartboardMessage(schoolId, classId, boardSessionId, text) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/teacher-message`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ board_session_id: boardSessionId, text }),
  });
  return parseResponse(res, 'Mesaj akıllı tahtaya gönderilemedi.');
}

export async function dismissSmartboardMessage(schoolId, classId, boardSessionId, messageId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/teacher-message/dismiss`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ board_session_id: boardSessionId, message_id: messageId }),
  });
  return parseResponse(res, 'Mesaj akıllı tahtadan kaldırılamadı.');
}

async function parseResponse(res, fallbackMessage) {
  const payload = await res.json().catch(() => null);
  if (!res.ok) {
    const error = new Error(payload?.detail || fallbackMessage);
    error.status = res.status;
    throw error;
  }
  return payload;
}

export async function fetchMiniTaskContentQaCatalog(schoolId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/content-qa/catalog`);
  return parseResponse(res, 'İncelenebilir içerikler alınamadı.');
}

export async function fetchTurkishL1Catalog(schoolId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/turkish-l1/catalog`);
  return parseResponse(res, 'Türkçe L1 Preview bilgisi alınamadı.');
}

export async function fetchTurkishL1Preview(schoolId, mode = 'preview', tour = 1, level = 1) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/turkish-l1/preview`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tour, mode, ...(level === 1 ? {} : { level }) }),
  });
  return parseResponse(res, 'Türkçe L1 Preview açılamadı.');
}

export async function fetchBalloonL1Preview(schoolId, mode = 'preview') {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/turkish-l1/balloon-preview`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mode }),
  });
  return parseResponse(res, 'Balon Patlat önizlemesi açılamadı.');
}

export async function fetchMiniTaskContentQaLevel(schoolId, previewId, level, { onlyUnreviewed = false } = {}) {
  const params = new URLSearchParams();
  if (onlyUnreviewed) params.set('only_unreviewed', 'true');
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(
    `/admin/mini-tasks/${encodeURIComponent(schoolId)}/content-qa/${encodeURIComponent(previewId)}/levels/${encodeURIComponent(level)}${suffix}`,
  );
  return parseResponse(res, 'Level soruları alınamadı.');
}

export async function fetchMiniTaskContentQaQuestions(schoolId, previewId, { level, onlyUnreviewed = false } = {}) {
  const params = new URLSearchParams();
  if (level !== undefined && level !== null && level !== '') params.set('level', String(level));
  if (onlyUnreviewed) params.set('only_unreviewed', 'true');
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(
    `/admin/mini-tasks/${encodeURIComponent(schoolId)}/content-qa/${encodeURIComponent(previewId)}/questions${suffix}`,
  );
  return parseResponse(res, 'QA soruları alınamadı.');
}

export async function saveMiniTaskContentQaReview(schoolId, previewId, level, review) {
  const res = await fetchJson(
    `/admin/mini-tasks/${encodeURIComponent(schoolId)}/content-qa/${encodeURIComponent(previewId)}/levels/${encodeURIComponent(level)}/review`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(review),
    },
  );
  return parseResponse(res, 'Değerlendirme kaydedilemedi.');
}

export async function fetchMiniTaskClassLink(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/link`);
  return parseResponse(res, 'Mini Görev link bilgisi alınamadı.');
}

export async function fetchSmartboardTeacherPin(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/teacher-pin`);
  return parseResponse(res, 'Öğretmen PIN bilgisi alınamadı.');
}

export async function rotateSmartboardTeacherPin(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/teacher-pin/rotate`, { method: 'POST' });
  return parseResponse(res, 'Yeni PIN oluşturulamadı.');
}

export async function createMiniTaskClassLink(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/link`, {
    method: 'POST',
  });
  return parseResponse(res, 'Mini Görev linki oluşturulamadı.');
}

export async function rotateMiniTaskClassLink(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/link/rotate`, {
    method: 'POST',
  });
  return parseResponse(res, 'Mini Görev linki yenilenemedi.');
}

export async function deactivateMiniTaskClassLink(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/link/deactivate`, {
    method: 'POST',
  });
  return parseResponse(res, 'Mini Görev linki pasifleştirilemedi.');
}

export async function fetchMiniTaskClassSummary(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/summary`);
  return parseResponse(res, 'Mini Görev sınıf özeti alınamadı.');
}

export async function fetchMiniTaskClassStudents(schoolId, classId) {
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/students`);
  return parseResponse(res, 'Mini Görev öğrenci level görünümü alınamadı.');
}

export async function fetchMiniTaskClassStatistics(schoolId, classId, { days } = {}) {
  const params = new URLSearchParams();
  if (days) params.set('days', String(days));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(`/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/statistics${suffix}`);
  return parseResponse(res, 'Mini Görev istatistikleri alınamadı.');
}

export async function fetchMiniTaskClassOutcomes(schoolId, classId, lessonId, { days } = {}) {
  const params = new URLSearchParams();
  if (lessonId) params.set('lesson_id', String(lessonId));
  if (days) params.set('days', String(days));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(
    `/admin/mini-tasks/${encodeURIComponent(schoolId)}/classes/${encodeURIComponent(classId)}/outcomes${suffix}`,
  );
  return parseResponse(res, 'Kazanım durumu alınamadı.');
}

export async function fetchWeeklyReadingOverview(schoolId, classId) {
  const params = new URLSearchParams();
  if (classId) params.set('class_id', String(classId));
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(`/admin/weekly-reading/overview/${encodeURIComponent(schoolId)}${suffix}`);
  return parseResponse(res, 'Haftalık okuma durumu alınamadı.');
}

export async function fetchWeeklyReadingAssignment(schoolId, assignmentId, options = {}) {
  const params = new URLSearchParams();
  if (options.includePassageBody) params.set('include_passage_body', 'true');
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const res = await fetchJson(`/admin/weekly-reading/overview/${encodeURIComponent(schoolId)}/assignments/${encodeURIComponent(assignmentId)}${suffix}`);
  return parseResponse(res, 'Haftalık okuma pasajı alınamadı.');
}

export async function deleteWeeklyReadingResult(schoolId, studentAssignmentId) {
  const res = await fetchJson(`/admin/weekly-reading/overview/${encodeURIComponent(schoolId)}/students/${encodeURIComponent(studentAssignmentId)}`, {
    method: 'DELETE',
  });
  return parseResponse(res, 'Okuma sonucu silinemedi.');
}
